<template>
    <CardPage :section="7" :page="11" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Well, we've made it to the end of a session together in the House of LifeSkills. Once again, you’ve made your Mother very proud! Here’s another
            trophy for your hard work.
        </p>
        <ResponsiveImage :src="trophy.image" :alt="trophy.text" flex="xs6" :imgClass="'shine'"></ResponsiveImage>
        <p>
            Remember:<br />
            Breaking down barriers: I’m worth it! I deserve it! And I know how to get it!
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        trophy: get('section7/trophy')
    },
    methods: {
        finish() {
            this.$store.set('section7/complete', true);
            this.$store.set('section7/trophy@earned', true);
        }
    }
};
</script>
